package components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import shared.content.NavigationDefaults

@Composable
fun Footer(onNavigate: (String) -> Unit) {
    Footer(attrs = {
        style {
            position(Position.Relative)
            property("padding", "4rem 1.5rem")
            property("overflow", "hidden")
            property("background-color", "var(--surface)")
            property("color", "var(--on-surface)")
        }
    }) {
        Div(attrs = {
            style {
                position(Position.Relative)
                maxWidth(80.cssRem)
                property("margin", "0 auto")
            }
        }) {
            Div(attrs = {
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    alignItems(AlignItems.Center)
                    gap(3.cssRem)
                }
            }) {
                // Navigation links
                Nav(attrs = {
                    attr("aria-label", "Footer navigation")
                    style {
                        display(DisplayStyle.Flex)
                        alignItems(AlignItems.Center)
                        gap(2.cssRem)
                    }
                }) {
                    NavigationDefaults.footerLinks.forEach { link ->
                        A(attrs = {
                            style {
                                fontSize(0.875.cssRem)
                                fontWeight(500)
                                property("transition", "all 0.3s ease")
                                property("padding", "0.25rem 0.5rem")
                                property("color", "var(--on-surface-variant)")
                                textDecoration("none")
                                cursor("pointer")
                            }
                            onClick { e ->
                                e.preventDefault()
                                onNavigate(link.href)
                            }
                            attr("href", link.href)
                        }) {
                            Text(link.text)
                        }
                    }
                }

                // Divider
                Div(attrs = {
                    style {
                        width(100.percent)
                        maxWidth(48.cssRem)
                        height(1.px)
                        opacity(0.1)
                        property("background", "linear-gradient(to right, transparent, var(--on-surface), transparent)")
                    }
                })

                // Copyright
                Div(attrs = {
                    style {
                        textAlign("center")
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        gap(0.75.cssRem)
                    }
                }) {
                    P(attrs = {
                        style {
                            fontSize(0.75.cssRem)
                            letterSpacing(0.1.em)
                            property("text-transform", "uppercase")
                            opacity(0.6)
                            property("color", "var(--on-surface-variant)")
                        }
                    }) {
                        Text("\u00A9 2026 Reaptive. All rights reserved.")
                    }
                }
            }
        }
    }
}
